import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";


const EditTimezoneFormat = ({ show, onClose }) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const options = [
        { value: "India", label: "India"},
        { value: "Singapore", label: "Singapore" },
        { value: "USA", label: "USA" },
    ];

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#dcf1dc' }}>
                    <h3 className="modal-title">Update Time Zone Format</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Country <span className="required">*</span></label>
                            <Select placeholder="Select Country"
                                defaultValue={options[1]}
                                onChange={setSelectedOption}
                                options={options}
                            />
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Time Zone Name<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Time Zone Name" value={"Asia/Kolkata	"}/>
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">UTC offset<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter UTC offset" value={"UTC +05:30"}/>
                        </div>
                       
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Update Time Zone Format</Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditTimezoneFormat;
